import { Box, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import SendIcon from "../../../assets/images/icons/SendIcon.tsx";
import BriaInput from "../BriaInput/BriaInput.tsx";
import ConfirmationPopup from "../ConfirmationPopup/ConfirmationPopup.tsx";
import styles from "./GeneralFeedbackPopup.module.scss";
import { useAppStore } from "../../../hooks/useStores.tsx";

type FeedbackForm = {
	description: string;
};

type Props = {
	open: boolean;
	onClose: () => void;
};

const GeneralFeedbackPopup = ({ open, onClose }: Props) => {
	const { t } = useTranslation("translation", { keyPrefix: "sideMenu.feedbackPopup" });
	const { appStore} = useAppStore();
	const [feedbackForm, setFeedbackForm] = useState<FeedbackForm>({ description: "" });
	const [loadingSendFeedback, setLoadingSendFeedback] = useState(false);
	const [isFeedbackSent, setIsFeedbackSent] = useState(false);

	useEffect(() => {
		if (isFeedbackSent) {
			setTimeout(onClose, 3000);
		}
	}, [isFeedbackSent]);

	const handleFeedbackFormChange = <K extends keyof FeedbackForm>(key: K, value: FeedbackForm[K]) => {
		setFeedbackForm((prevForm) => ({ ...prevForm, [key]: value }));
	};

	const sendFeedback = async () => {
		try {
			setLoadingSendFeedback(true);
			// TODO: Actually send an email to the relevant channel as Gabi decides
			// await new QueryService("/contact").post("/feedback", feedbackForm)
			await appStore.shareFeedback(feedbackForm.description);
			setIsFeedbackSent(true);
		} finally {
			setLoadingSendFeedback(false);
		}
	};

	return (
		<ConfirmationPopup
			open={open}
			onClose={onClose}
			onClick={sendFeedback}
			title={t("title")}
			description={
				!isFeedbackSent ? (
					<BriaInput
						placeholder={t("placeholder")}
						value={feedbackForm.description}
						onChange={(e) => handleFeedbackFormChange("description", e.target.value)}
						multiline
						minRows={3}
						fullWidth
					/>
				) : (
					<Box className={styles.sentFeedback}>
						<SendIcon />
						<Typography className={styles.sentDescription}>{t("sentDescription")}</Typography>
					</Box>
				)
			}
			confirmButtonText={!isFeedbackSent && t("confirmButton")}
			loading={loadingSendFeedback}
			hideCancel
			paperClassName={styles.feedbackPopup}
		/>
	);
};

export default observer(GeneralFeedbackPopup);
